<div class="auth-page-canvas">
  <div class="auth-ambient-orb auth-ambient-orb-top" aria-hidden="true"></div>
  <div class="auth-ambient-orb auth-ambient-orb-bottom" aria-hidden="true"></div>

  <!-- Tarjeta Central Glass Card (idéntica a React LoginView.jsx, sin OAuth2, sin 2FA y sin Olvidé contraseña) -->
  <div class="auth-card glass-card">
    <!-- Cabecera de Marca ABAQ Querétaro -->
    <div class="auth-brand-header">
      <div class="auth-logo-badge">
        <img
          src="/abaq.png"
          alt="Logo ABAQ Querétaro"
          class="auth-brand-img"
          style="width: 44px; height: 44px; object-fit: contain;"
          onerror="this.style.display='none'"
        />
        <div class="auth-brand-title-group">
          <span class="auth-brand-wordmark">ABAQ</span>
          <span class="auth-brand-dot" aria-hidden="true"></span>
        </div>
      </div>
      <span class="auth-brand-kicker">Acceso al Portal</span>
      <h1 class="auth-card-title">Iniciar sesión en ABAQ</h1>
      <p class="auth-card-subtitle">
        Ingresa tus credenciales para acceder a tu panel de Servicio Social o Voluntariado.
      </p>
    </div>

    <!-- Banner de error de validación -->
    @if (errorMessage) {
      <div class="auth-alert-error" role="alert">
        <span class="material-symbols-outlined auth-alert-icon">error</span>
        <span class="auth-alert-text">{{ errorMessage }}</span>
      </div>
    }

    <!-- Formulario de Inicio de Sesión -->
    <form
      #loginFormEl
      class="auth-form"
      [formGroup]="loginForm"
      (ngSubmit)="SignIn()"
      (keydown)="handleFormKeyDown($event)"
      novalidate
    >
      <!-- Campo 1: Correo electrónico -->
      <div class="auth-field-group">
        <label for="login-email" class="auth-field-label">
          Correo electrónico
        </label>
        <div class="custom-input-wrapper">
          <span class="material-symbols-outlined custom-input-icon" aria-hidden="true">
            alternate_email
          </span>
          <input
            #emailInput
            id="login-email"
            type="email"
            class="custom-input"
            formControlName="email"
            placeholder="nombre.apellido@alumnos.uaq.edu.mx o correo personal"
            autocomplete="email"
          />
        </div>
        <span class="auth-field-hint">
          Ingresa tu correo institucional universitario (Servicio Social) o personal (Voluntariado General).
        </span>
      </div>

      <!-- Campo 2: Contraseña con Toggle (sin ¿Olvidaste tu contraseña?) -->
      <div class="auth-field-group">
        <div class="auth-field-header-row">
          <label for="floatingPassword" class="auth-field-label">
            Contraseña
          </label>
        </div>
        <div class="custom-input-wrapper">
          <span class="material-symbols-outlined custom-input-icon" aria-hidden="true">
            lock
          </span>
          <input
            id="floatingPassword"
            [type]="passwordVisible ? 'text' : 'password'"
            class="custom-input has-toggle"
            formControlName="password"
            placeholder="Ingresa tu clave de acceso"
            autocomplete="current-password"
          />
          <button
            type="button"
            id="togglePasswordBtn"
            [attr.aria-label]="passwordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            class="custom-input-toggle-btn"
            (click)="togglePasswordVisibility()"
          >
            <span class="material-symbols-outlined text-lg" id="passwordIcon">
              {{ passwordVisible ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
        </div>
      </div>

      <!-- Botón de Submit -->
      <button
        id="login-submit-btn"
        type="submit"
        class="btn-auth-submit"
        [class.btn-loading]="isLoading"
        [disabled]="isLoading"
      >
        @if (!isLoading) {
          <span>Iniciar sesión en ABAQ</span>
          <span class="material-symbols-outlined text-lg">login</span>
        } @else {
          <span class="material-symbols-outlined text-lg animate-spin">progress_activity</span>
          <span>Validando credenciales...</span>
        }
      </button>
    </form>

    <!-- Pie de Tarjeta con Enlace a Registro (sin Passkey / OAuth2) -->
    <div class="auth-card-footer">
      <p class="auth-footer-text">
        ¿Nuevo voluntario?
        <button
          type="button"
          class="auth-link-register"
          (click)="navigateToSignup()"
        >
          Crear cuenta en ABAQ
        </button>
      </p>
    </div>
  </div>
</div>